/**
 * Projects API Service — v3 Project Multi-Tenancy
 * Handles all API calls for org projects (the atomic unit of FundMatch v3)
 */
import apiClient from '../lib/apiClient';

/** Create a new project for an org */
export const createProject = async (bn, projectData) => {
  const response = await apiClient.post(`/orgs/${bn}/projects`, projectData);
  return response.data;
};

/** List all projects for an org (optionally filtered) */
export const listOrgProjects = async (bn, { status, year } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (year)   params.year   = year;
  const response = await apiClient.get(`/orgs/${bn}/projects`, { params });
  return response.data;
};

/** Get a single project by ID */
export const getProject = async (projectId) => {
  const response = await apiClient.get(`/projects/${projectId}`);
  return response.data;
};

/** Update project fields */
export const updateProject = async (projectId, updates) => {
  const response = await apiClient.patch(`/projects/${projectId}`, updates);
  return response.data;
};

/** Delete a project */
export const deleteProject = async (projectId) => {
  await apiClient.delete(`/projects/${projectId}`);
};

/** Set or update L2-L4 goals for a project */
export const setProjectGoals = async (projectId, goals) => {
  const response = await apiClient.post(`/projects/${projectId}/goals`, goals);
  return response.data;
};

/** Run grant discovery for a project */
export const discoverProjectMatches = async (projectId) => {
  const response = await apiClient.post(`/projects/${projectId}/discover`);
  return response.data;
};

/** Get latest match run results for a project */
export const getProjectMatches = async (projectId, runId) => {
  const params = runId ? { run_id: runId } : {};
  const response = await apiClient.get(`/projects/${projectId}/matches`, { params });
  return response.data;
};

/** Get M1-M8 measures in project context */
export const getProjectMeasures = async (projectId, runId) => {
  const params = runId ? { run_id: runId } : {};
  const response = await apiClient.get(`/projects/${projectId}/measures`, { params });
  return response.data;
};
